import React, { useContext, useMemo } from 'react';
import {
	ICreateModifierGroupsContext,
	CreateModifierGroupsContext,
} from '../../createModifierGroupsState/createModifierGroupsContext';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './CreateModifierGroupsControlPanel.module.scss';

const CreateModifierGroupsControlPanel: React.FC = () => {
	const { changeVisibleForm, visibleForm, defaultCustomerLanguage, translations } =
		useContext<ICreateModifierGroupsContext>(CreateModifierGroupsContext);

	const hasTranslationError = useMemo(() => {
		if (!defaultCustomerLanguage) {
			return false;
		}
		const defaultNameTranslation = translations.find(
			(translation) => translation.languageId === defaultCustomerLanguage.id,
		)?.name;
		return !defaultNameTranslation;
	}, [defaultCustomerLanguage, translations]);

	return (
		<div className={style.container} data-test="CreateModifierGroupsControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default CreateModifierGroupsControlPanel;
